import { SearchResult } from '../types/';

export const fakeResults: SearchResult[] = [
  {
    firstName: 'Martin',
    lastName: 'ROY',
    mail: 'martin.roy13@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GAULTIER',
    mail: 'martin.gaultier26@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Margot',
    lastName: 'MARTIN-DENAVIT',
    mail: 'margot.martindenav15@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'KAAZAN',
    mail: 'martin.kaazan19@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BROYER',
    mail: 'martin.broyer22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Paul',
    lastName: 'DONJON de SAINT MARTIN',
    mail: 'paul.donjondesaint26@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Romain',
    lastName: 'DUMARTIN',
    mail: 'romain.dumartin14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Sami',
    lastName: 'MARTIN',
    mail: 'sami.martin12@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Léana Clara',
    lastName: 'MARTIN',
    mail: 'leana.martin21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LABBÉ',
    mail: 'martin.labbe25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Valentine',
    lastName: 'MARTIN',
    mail: 'valentine.martin24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GOUEZ',
    mail: 'martin.gouez27@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'DUPUIS',
    mail: 'martin.dupuis06@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Nathanaël',
    lastName: 'MARTINEAU',
    mail: 'nathanael.martinea09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GAVELLE',
    mail: 'martin.gavelle10@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'MANCEAU',
    mail: 'martin.manceau07@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: "D'USSEL",
    mail: 'martin.dussel18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'VIGAN',
    mail: 'martin.vigan09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Antoine',
    lastName: 'MARTIN',
    mail: 'antoine.martin22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'HENNEBO-MORGUE',
    mail: 'martin.hennebomorg05@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Manon',
    lastName: 'MARTIN',
    mail: 'manon.martin10@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GERARD',
    mail: 'martin.gerard19@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Anaëlle',
    lastName: 'MARTINEAU',
    mail: 'anaelle.martineau09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Agathe',
    lastName: 'MARTIN-DENAVIT',
    mail: 'agathe.martindenav29@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Hubert',
    lastName: 'LAGROY DE CROUTTE DE SAINT MARTIN',
    mail: 'hubert.lagroydecro09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'KIRCHNER',
    mail: 'martin.kirchner21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Dorian',
    lastName: 'MARTIN',
    mail: 'dorian.martin28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Mia',
    lastName: 'MARTIN',
    mail: 'mia.martin07@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LEMAITRE',
    mail: 'martin.lemaitre25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Enoal',
    lastName: 'MARTIN',
    mail: 'enoal.martin28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Antoine',
    lastName: 'MARTINEAU',
    mail: 'antoine.martineau24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Aitana',
    lastName: 'GONZALEZ MARTINEZ',
    mail: 'aitana.gonzalezmar18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Sana',
    lastName: 'BOULOUIZ MARTINEZ',
    mail: 'sana.boulouizmarti22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Gabriel',
    lastName: 'MARTIN',
    mail: 'gabriel.martin02@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Tom',
    lastName: 'MARTIN',
    mail: 'tom.martin26@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Louis François',
    lastName: 'MARTIN',
    mail: 'louisfrancois.mart05@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'NGUYEN',
    mail: 'martin.nguyen03@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BUNIAS',
    mail: 'martin.bunias24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Maëliss',
    lastName: 'MARTIN',
    mail: 'maeliss.martin03@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'RACHEL',
    mail: 'martin.rachel24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Simon',
    lastName: 'MARTIN',
    mail: 'simon.martin29@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Charlotte',
    lastName: 'MARTIN',
    mail: 'charlotte.martin07@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'FILLATRE',
    mail: 'martin.fillatre12@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Elliot',
    lastName: 'GORDON-MARTINS',
    mail: 'elliot.gordonmarti12@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GALICHON',
    mail: 'martin.galichon21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Thea',
    lastName: 'MARTIN',
    mail: 'thea.martin31@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'JOURDAN',
    mail: 'martin.jourdan08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'WERTHEIMER',
    mail: 'martin.wertheimer29@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BRET',
    mail: 'martin.bret21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Capucine',
    lastName: 'MARTIN-ZOÏLE',
    mail: 'capucine.martinzoi21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Lola',
    lastName: 'MARTIN',
    mail: 'lola.martin05@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LE PELTIER',
    mail: 'martin.lepeltier13@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Alexis',
    lastName: 'MARTIN',
    mail: 'alexis.martin20@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martine',
    lastName: 'DAKAYI KAMENI',
    mail: 'martine.dakayikame23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'JOULIE',
    mail: 'martin.joulie24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin Jordan',
    lastName: 'OYONO EDOU',
    mail: 'martinjordan.oyono23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Fanny',
    lastName: 'MARTIN',
    mail: 'fanny.martin23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'de SMEDT',
    mail: 'martin.desmedt08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Baptyste Wade Martin',
    lastName: 'AGRICOLE',
    mail: 'baptystewademartin08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Manon',
    lastName: 'MARTINEZ',
    mail: 'manon.martinez04@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Enzo',
    lastName: 'MARTINEZ',
    mail: 'enzo.martinez17@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Pedro',
    lastName: 'MARTINEZ SANTANA',
    mail: 'pedro.martinez28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Henri-Martin',
    lastName: 'KAKOU MAYAZA',
    mail: 'henrimartin.kakoum05@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'CHARRIER',
    mail: 'martin.charrier04@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GARENAUX',
    mail: 'martin.garenaux011@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Justine',
    lastName: 'MARTIN',
    mail: 'justine.martin08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Hugo',
    lastName: 'MARTIN',
    mail: 'hugo.martin20@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Laurine',
    lastName: 'MARTIN VO',
    mail: 'laurine.martinvo17@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Eliot',
    lastName: 'MARTIN',
    mail: 'eliot.martin21@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Romain',
    lastName: 'MARTIN',
    mail: 'romain.martin15@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Emma',
    lastName: 'MARTIN',
    mail: 'emma.martin19@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'ESCARD',
    mail: 'martin.escard10@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Victor',
    lastName: 'MARTINEAU',
    mail: 'victor.martinea14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Farhane Martin, Florian, Achamou',
    lastName: 'DA SILVA',
    mail: 'farhane.dasilva14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'MARTIN SAIDOU',
    lastName: 'SENE',
    mail: 'martin.sene27@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Luca',
    lastName: 'MARTIN',
    mail: 'luca.martin24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'FOLLIOT',
    mail: 'martin.folliot25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'PESSON',
    mail: 'martin.pesson14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GABRIEL',
    mail: 'martin.gabriel111@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Diana',
    lastName: 'CORREIA MARTINS',
    mail: 'diana.correiam25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Julie',
    lastName: 'MARTIN',
    mail: 'julie.martin19@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Fred Alexander',
    lastName: 'DIAZ MARTIN',
    mail: 'fredalexa.diazmart27@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'NOEL',
    mail: 'martin.noel17@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BÉE',
    mail: 'martin.bee04@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Laura Martina',
    lastName: 'DAMMEL',
    mail: 'lauramart.dammel13@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Léo',
    lastName: 'BURDIN DE SAINT MARTIN',
    mail: 'leo.burdinde09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'FABRE',
    mail: 'martin.fabre02@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'RIOU',
    mail: 'martin.riou16@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GONZALEZ',
    mail: 'martin.gonzalez01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Cétina',
    lastName: 'MARTINI',
    mail: 'cetina.martini18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'MARILLER',
    mail: 'martin.mariller18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Alicia',
    lastName: 'MARTINS BARATA',
    mail: 'alicia.martinsb30@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Vincent',
    lastName: 'MARTINEZ',
    mail: 'vincent.martinez22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Paul',
    lastName: 'MARTIN',
    mail: 'paul.martin18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Enzo',
    lastName: 'MARTINEZ',
    mail: 'enzo.martinez23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin ',
    lastName: 'SLIWA',
    mail: 'martin.sliwa01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LEFEBVRE',
    mail: 'martin.lefebvre15@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Liana',
    lastName: 'MARTINS',
    mail: 'liana.martins08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Arthur',
    lastName: 'LAMARTINE',
    mail: 'arthur.lamartin19@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Clémence',
    lastName: 'MARTIN',
    mail: 'clemence.martin01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Joao',
    lastName: 'MARTINS',
    mail: 'joao.martins17@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Derian',
    lastName: 'RODRIGUEZ MARTINEZ',
    mail: 'derian.rodrigue25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'FRANCK',
    mail: 'martin.franck26@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Daniel',
    lastName: 'MARTINEZ',
    mail: 'daniel.martinez30@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martina',
    lastName: 'PRESTI',
    mail: 'martina.presti08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BETTINGER',
    mail: 'martin.bettinge25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Gabriel',
    lastName: 'MARTIN',
    mail: 'gabriel.martin06@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Aurélien',
    lastName: 'MARTIN',
    mail: 'aurelien.martin27@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martina',
    lastName: 'CERNA',
    mail: 'martina.cerna28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'BUSTAMANTE',
    mail: 'martin.bustaman29@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Francisca',
    lastName: 'ALLENDE MARTINEZ',
    mail: 'francisca.allendem02@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Rita',
    lastName: 'CUNHA MATIAS MARTINO',
    mail: 'rita.cunhamat08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Ange-Paul',
    lastName: 'MARTINI PEMEZEC',
    mail: 'angepaul.martinip04@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Ricky Martin',
    lastName: 'KONA',
    mail: 'rickymart.kona01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Arianna',
    lastName: 'MARTINI',
    mail: 'arianna.martini15@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martina',
    lastName: 'DAVIDOV',
    mail: 'martina.davidov08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LECACHEUR',
    mail: 'martin.lecacheu23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Raquel',
    lastName: 'MARTINS',
    mail: 'raquel.martins26@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'PILLET',
    mail: 'martin.pillet11@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LEVASSEUR',
    mail: 'martin.levasseu14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'LE BRIS',
    mail: 'martin.lebris28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'JUNG',
    mail: 'martin.jung22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'TABANELLI',
    mail: 'martin.tabanell23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Edgar',
    lastName: 'MARTIN',
    mail: 'edgar.martin18@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'ZOLVER',
    mail: 'martin.zolver08@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Norah',
    lastName: 'MARTIN',
    mail: 'norah.martin22@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Robin',
    lastName: 'MARTINEZ',
    mail: 'robin.martinez09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Diane',
    lastName: 'MARTINS',
    mail: 'diane.martins03@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GUILLEAU',
    mail: 'martin.guilleau25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Shen',
    lastName: 'MARTINEZ',
    mail: 'shen.martinez01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Raphaël',
    lastName: 'MARTIN',
    mail: 'raphael.martin11@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'DREUX',
    mail: 'martin.dreux25@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'CHENUT',
    mail: 'martin.chenut17@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GABASTON',
    mail: 'martin.gabaston02@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Damien',
    lastName: 'MARTINE',
    mail: 'damien.martine14@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'FERRAN',
    mail: 'martin.ferran23@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'GILLET',
    mail: 'martin.gillet24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Dylan',
    lastName: 'MARTINEZ-TELLENNE',
    mail: 'dylan.martinez01@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martin',
    lastName: 'SOULIÉ',
    mail: 'martin.soulie11@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Ricardo',
    lastName: 'MARTINEZ',
    mail: 'ricardo.martinez30@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Martina',
    lastName: 'LEONE DODERO',
    mail: 'martina.leonedod28@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Tiphany Martine',
    lastName: 'PIQUENOT',
    mail: 'tiphanyma.piquenot20@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Quentin',
    lastName: 'MARTINS',
    mail: 'quentin.martins09@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Manon, Dany, Martine',
    lastName: 'MAJERES',
    mail: 'manondany.majeres24@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Emma',
    lastName: 'MARTINS',
    mail: 'emma.martins07@em-normandie.fr',
    photo: null,
  },
  {
    firstName: 'Fanny',
    lastName: 'DE FRIAS MARTINS',
    mail: 'fanny.defriasm05@em-normandie.fr',
    photo: null,
  },
];
